module.exports = __webpack_public_path__ + "img/icone-talhoes.7376295a.svg";